<template>
  <div>
    <p class="title">
      <span v-if="!isAdditional&&questionTotal>1">
        <i class="questionIndex"> {{ questionIndex + 1 }}</i>
        <i class="questionTotal">/{{ questionTotal }}</i>
      </span>
      <span v-else :alt="$t('questionaire.superadditionTopic')"></span>
      {{ questionData.question }}
      <b class="select-type">({{$t('questionaire.graphic')}})</b>
      <b v-if="questionData.isOptional == 0" class="must-notice">*</b>
    </p>
    <div class="log-form-group">
      <upload-img :files="imgFiles" :readonly="!isEditable" @imgList="afterUpload" />
    </div>
    <label>
      <van-field
        class="custom-filed"
        v-model="questionData.inputAnswer"
        rows="1"
        autosize
        :readonly="!isEditable"
        type="textarea"
        :placeholder="$t('questionaire.desc')"
        @blur="inputItem"
      />
    </label>
  </div>
</template>
<script>
import uploadImg from '@/components/selfUploadImg'

export default {
  name: 'TextAndPictureQuestion',
  components: { uploadImg },
  props: {
    isPreview: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    isAdditional: {
      type: Boolean,
      default: false
    },
    questionData: Object,
    questionIndex: Number,
    questionTotal: Number,
    afterAnswered: Function
  },
  data() {
    return {
      imgFiles: []
    }
  },
  created() {
    if (this.questionData.imgUrlsAnswer) {
      for (var i = 0; i < this.questionData.imgUrlsAnswer.length; i++) {
        this.imgFiles.push({
          url: this.questionData.imgUrlsAnswer[i]
        })
      }
    }
  },
  methods: {
    afterUpload(data) {
      if (!this.isEditable) {
        return
      }
      this.questionData.imgUrlsAnswer = []
      if (data) {
        for (var i = 0; i < data.length; i++) {
          this.questionData.imgUrlsAnswer.push(data[i].url)
        }
      }

      this.afterAnswered(this.questionData)
    },
    inputItem() {
      if (!this.isEditable) {
        return
      }
      this.afterAnswered(this.questionData)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-filed{
  background: #F5F6FA;
  padding:.25rem;
  font-size:.6rem;
  color:#666666;
  border-radius: .25rem;
}
.edit {
  width: 95%;
  background: #F5F6FA;
  padding: .25rem;
  height: auto;
  overflow-x: visible;
  overflow-y: visible;
  font-size: .6rem;
}
.log-form-group{
  margin-bottom:.25rem;
}
</style>
